

//Using MUI

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Grid,
//   TextField,
//   Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Checkbox,
//   FormControlLabel,
//   Alert,
//   Avatar,
//   CssBaseline,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Fade,
//   Card,
//   CardContent,
//   useTheme, useMediaQuery
// } from "@mui/material";
// import {
//   Phone as PhoneIcon,
//   Add as AddIcon,
//   ArrowForward as ArrowForwardIcon,
//   Close as CloseIcon,
//   CheckCircle as CheckCircleIcon,
// } from "@mui/icons-material";
// import Login from "../assets/Login.jpeg";
// import AuraVideo from "../assets/Aura-bg.mp4";
// import { keyframes } from "@mui/system";

// export default function Patientlogin() {
//   const [contact, setContact] = useState("");
//   const [otp, setOtp] = useState("");
//   const [generatedOtp, setGeneratedOtp] = useState(null);
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [popupmessage, setPopupmessage] = useState("");
//   const [patientdetails, setPatientdetails] = useState([]);
//   const [patientlistpopup, setPatientlistpopup] = useState(false);
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const validateContact = (contact) => /^[0-9]{10}$/.test(contact);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));





//   const pulseLogo = keyframes`
//     0% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
//     50% { transform: scale(1.1); filter: drop-shadow(0 0 20px white); }
//     100% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
//   `;


//   const checkUserExists = async (contact) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/CheckUserExists`,
//         { contact }
//       );
//       return response.status === 200;
//     } catch (error) {
//       setErrorMessage("User not registered. Please sign up first.");
//       return false;
//     }
//   };

//   const sendOtp = async () => {
//     if (!validateContact(contact)) {
//       setErrorMessage("Please enter a valid 10-digit mobile number");
//       return;
//     }

//     setIsLoading(true);
//     const userExists = await checkUserExists(contact);
//     if (!userExists) {
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/patient-login-contact`,
//         { contact }
//       );

//       setGeneratedOtp(response.data.otpcode);
//       setPopupmessage("OTP sent successfully to your mobile number");
//       setIsOtpSent(true);
//       setErrorMessage("");
//     } catch (error) {
//       setErrorMessage(
//         error.response?.data?.message || "Failed to send OTP. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const proceedWithLogin = async () => {
//     if (!selectedPatient) {
//       setErrorMessage("Please select a user to proceed.");
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/patient-login-api`,
//         { patientcode: selectedPatient.MPD_PATIENT_CODE }
//       );

//       localStorage.setItem("Token", response.data.Token);
//       localStorage.setItem("Email", response.data.Email);
//       localStorage.setItem("isLoggedIn", true);
//       localStorage.setItem("PatientCode", selectedPatient.MPD_PATIENT_CODE);
//       localStorage.setItem("Name", selectedPatient.MPD_PATIENT_NAME);
//       localStorage.setItem("Contact", selectedPatient.MPD_MOBILE_NO);
//       localStorage.setItem("Role", response.data.Role);

//       setErrorMessage("");
//       setPatientlistpopup(false);
//       navigate("/home");
//     } catch (error) {
//       setErrorMessage("An error occurred during login.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchPatientList = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/userlists`,
//         { contact }
//       );

//       setPatientdetails(response.data);
//       setPopupmessage("Please select your profile to continue");
//       setPatientlistpopup(true);
//     } catch (error) {
//       setErrorMessage("Failed to fetch patient details.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLogin = async () => {
//     if (otp === generatedOtp?.toString()) {
//       await fetchPatientList();
//     } else {
//       setErrorMessage("Invalid OTP. Please try again.");
//     }
//   };

//   const handleCancel = () => {
//     setContact("");
//     setOtp("");
//     setIsOtpSent(false);
//     setErrorMessage("");
//   };

//   return (
//     <>
//       <CssBaseline />
//       <Grid container sx={{ height: "100vh", display: "flex" }}>
//         <Grid
//   item
//   xs={12}
//   md={6}
//   sx={{
//     width: { xs: "100%", md: "50%" },
//     position: "relative",
//     overflow: "hidden",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//   }}
// >
//   {/* 🎥 Video background */}
//   <video
//     autoPlay
//     loop
//     muted
//     playsInline
//     style={{
//       position: "absolute",
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//       zIndex: -1,
//       opacity: 1, // full brightness
//     }}
//   >
//     <source src={AuraVideo} type="video/mp4" />
//   </video>
          

         
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <Box
//             sx={{
//               p: { xs: 3, md: 8 },
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               height: "100%",
//               ml: { xs: 0, md: 10 },
//             }}
//           >
//            <Box
//                     component="img"
//                     src={require("../assets/AuraLogo.png")}
//                     alt="Logo"
//                     sx={{
//                       width: isMobile ? 180 : 220,
//                       height: "auto",
//                       alignSelf: "center",
//                       mb: 2,
//                       animation: `${pulseLogo} 3s infinite ease-in-out`,
//                       filter: `
//                         drop-shadow(0 0 8px white)
//                         drop-shadow(0 0 16px white)
//                         drop-shadow(0 0 24px rgba(149, 117, 205, 1))
//                       `
//                     }}
//                   />

          
//             <Typography variant="h4"
//               component="h2"
//               gutterBottom
//               sx={{ fontWeight: 700 }}>
//               Patient Login
//             </Typography>
//             <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
//               Enter your mobile number to receive OTP
//             </Typography>

//             <TextField
//               label="Mobile Number"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               value={contact}
//               inputProps={{ maxLength: 10 }}
//               onChange={(e) => setContact(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <PhoneIcon color="primary" />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mb: 2 }}
//             />

//             {!isOtpSent ? (
//               <Button
//                 variant="contained"
//                 fullWidth
//                 size="large"
//                 onClick={sendOtp}
//                 disabled={isLoading}
//                 sx={{
//                   py: 1.5, mt: 1, fontWeight: 700,
//                   background: 'linear-gradient(45deg, #b39ddb, #d1c4e9)',
//               '&:hover': { background: 'linear-gradient(45deg, #9575cd, #b39ddb)' },

//                 }}
//               >
//                 {isLoading ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Send OTP"
//                 )}
//               </Button>
//             ) : (
//               <Fade in={isOtpSent}>
//                 <Box>
//                   {popupmessage && (
//                     <Alert
//                       icon={<CheckCircleIcon fontSize="inherit" />}
//                       severity="success"
//                       sx={{ mb: 2 }}
//                     >
//                       {popupmessage}
//                     </Alert>
//                   )}

//                   <TextField
//                     label="Enter OTP"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <AddIcon color="action" />
//                         </InputAdornment>
//                       ),
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={handleCancel}
//                             edge="end"
//                             size="small"
//                           >
//                             <CloseIcon fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{ mb: 2 }}
//                   />

//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12} sm={6}>
//                       <Button
//                         variant="contained"
//                         fullWidth
//                         size="large"
//                         onClick={handleLogin}
//                         disabled={isLoading || !otp}
//                         endIcon={<ArrowForwardIcon />}
//                         sx={{ py: 1.5 }}
//                       >
//                         {isLoading ? (
//                           <CircularProgress size={24} color="inherit" />
//                         ) : (
//                           "Verify"
//                         )}
//                       </Button>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Button
//                         variant="outlined"
//                         fullWidth
//                         size="large"
//                         onClick={handleCancel}
//                         disabled={isLoading}
//                         sx={{ py: 1.5 }}
//                       >
//                         Cancel
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Fade>
//             )}

//             {errorMessage && (
//               <Alert severity="error" sx={{ mt: 2 }}>
//                 {errorMessage}
//               </Alert>
//             )}

//             <Typography
//               variant="body2"
//               color="textSecondary"
//               align="center"
//               sx={{ mt: 3 }}
//             >
//               By continuing, you agree to our Terms of Service and Privacy
//               Policy
//             </Typography>

//             <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3, mt:3 }}>
//       <Button
//         component={Link}
//         to="/addusers"
//         variant="outlined"
//         size="small"
//         sx={{
//           fontWeight: 500,
//           color: "primary.main",
//           borderColor: "primary.main",
//           "&:hover": { backgroundColor: "rgba(25,118,210,0.1)" },
//         }}
//       >
//         Create Account
//       </Button>
//     </Box>
//           </Box>
//         </Grid>
//       </Grid>

//       <Dialog
//         open={patientlistpopup}
//         onClose={() => setPatientlistpopup(false)}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 3 } }}
//       >
//         <DialogTitle
//           sx={{
//             bgcolor: "#f5f5f5",
//             borderBottom: 1,
//             borderColor: "divider",
//           }}
//         >
//           <Typography variant="h6">Select Your Profile</Typography>
//           <Typography variant="body2" color="textSecondary">
//             {popupmessage}
//           </Typography>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0 }}>
//           {patientdetails.length > 0 ? (
//             <Box>
//               {patientdetails.map((patientDetail, index) => (
//                 <Card
//                   key={index}
//                   variant="outlined"
//                   sx={{
//                     m: 2,
//                     cursor: "pointer",
//                     borderColor:
//                       selectedPatient === patientDetail
//                         ? "primary.main"
//                         : "divider",
//                     boxShadow:
//                       selectedPatient === patientDetail
//                         ? "0 0 0 2px #1976d2"
//                         : "none",
//                     transition: "all 0.2s ease-in-out",
//                   }}
//                   onClick={() => setSelectedPatient(patientDetail)}
//                 >
//                   <CardContent>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={selectedPatient === patientDetail}
//                           onChange={() =>
//                             setSelectedPatient(
//                               selectedPatient === patientDetail
//                                 ? null
//                                 : patientDetail
//                             )
//                           }
//                         />
//                       }
//                       label={
//                         <Box>
//                           <Typography variant="subtitle1">
//                             {patientDetail.MPD_PATIENT_NAME}
//                           </Typography>
//                           <Typography variant="body2" color="textSecondary">
//                             {patientDetail.MPD_MOBILE_NO}
//                           </Typography>
//                         </Box>
//                       }
//                     />
//                   </CardContent>
//                 </Card>
//               ))}
//             </Box>
//           ) : (
//             <Typography variant="body2" sx={{ p: 3 }}>
//               No patient records found.
//             </Typography>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setPatientlistpopup(false)} variant="outlined">
//             Cancel
//           </Button>
//           <Button
//             onClick={proceedWithLogin}
//             variant="contained"
//             disabled={!selectedPatient}
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }



import React, { useState ,useEffect} from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CssBaseline,
  InputAdornment,
  IconButton,
  CircularProgress,
  Fade,
} from "@mui/material";
import {
  Phone as PhoneIcon,
  Add as AddIcon,
  ArrowForward as ArrowForwardIcon,
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
   Home as HomeIcon
} from "@mui/icons-material";
import AuraVideo from "../assets/3.mp4";
import { keyframes } from "@mui/system";
import { useLocation } from "react-router-dom";

export default function Patientlogin() {
  const location = useLocation();
  const [contact, setContact] = useState("");
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [popupmessage, setPopupmessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateContact = (contact) => /^[0-9]{10}$/.test(contact);

  useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const contactFromUrl = searchParams.get('contact');
  
  if (contactFromUrl) {
    setContact(contactFromUrl);
    // Optional: Auto-send OTP when contact is pre-filled
    // You can add this if you want automatic OTP sending
    // sendOtp(); 
  }
}, [location]);



  const pulseLogo = keyframes`
    0% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
    50% { transform: scale(1.1); filter: drop-shadow(0 0 20px white); }
    100% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
  `;


  const checkUserExists = async (contact) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/CheckUserExists`,
        { contact }
      );
      return response.status === 200;
    } catch (error) {
      setErrorMessage("User not registered. Please sign up first.");
      return false;
    }
  };

  const sendOtp = async () => {
    if (!validateContact(contact)) {
      setErrorMessage("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsLoading(true);
    const userExists = await checkUserExists(contact);
    if (!userExists) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/patient-login-contact`,
        { contact }
      );

      setGeneratedOtp(response.data.otpcode);
      setPopupmessage("OTP sent successfully to your mobile number");
      setIsOtpSent(true);
      setErrorMessage("");
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const autoLoginUser = async () => {
    setIsLoading(true);
    try {
      // First, get the patient list
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/userlists`,
        { contact }
      );

      const patientList = response.data;
      
      if (patientList && patientList.length > 0) {
        // Automatically select the first patient (or only patient)
        const firstPatient = patientList[0];
        
        // Proceed with login using the first patient
        const loginResponse = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/patient-login-api`,
          { patientcode: firstPatient.MPD_PATIENT_CODE }
        );

        // Store user data and navigate
        localStorage.setItem("Token", loginResponse.data.Token);
        localStorage.setItem("Email", loginResponse.data.Email);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("PatientCode", firstPatient.MPD_PATIENT_CODE);
        localStorage.setItem("Name", firstPatient.MPD_PATIENT_NAME);
        localStorage.setItem("Contact", firstPatient.MPD_MOBILE_NO);
        localStorage.setItem("Role", loginResponse.data.Role);

        setErrorMessage("");
        navigate("/timeslots");
      } else {
        setErrorMessage("No patient profile found for this contact number.");
      }
    } catch (error) {
      setErrorMessage("Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogin = async () => {
    if (otp === generatedOtp?.toString()) {
      await autoLoginUser();
    } else {
      setErrorMessage("Invalid OTP. Please try again.");
    }
  };

  const handleHomeClick = () => {
    navigate("/"); // Navigate to home page
  };


  const handleCancel = () => {
    setContact("");
    setOtp("");
    setIsOtpSent(false);
    setErrorMessage("");
  };

  return (
    <>
      <CssBaseline />
      <Box sx={{ 
        position: "relative",
        height: "100vh", 
        width: "100vw",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        {/* 🎥 Full Screen Video background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            minWidth: "100%",
            minHeight: "100%",
            width: "auto",
            height: "auto",
            transform: "translate(-50%, -50%)",
            objectFit: "cover",
            zIndex: -2,
            opacity: 1,
          }}
        >
          <source src={AuraVideo} type="video/mp4" />
        </video>
        
        {/* Overlay to improve form readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: -1,
          }}
        />

         {/* <Button
          startIcon={<HomeIcon />}
          onClick={handleHomeClick}
          variant="contained"
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            zIndex: 10,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            color: "primary.main",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 1)",
            },
            fontWeight: 600,
          }}
        >
          Home
        </Button> */}

        {/* Centered Login Form */}
        <Box sx={{ 
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 450,
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          px: 3
        }}>
          <Box
            sx={{
              p: { xs: 4, md: 5 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              borderRadius: 4,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(10px)",
              textAlign: "center"
            }}
          >
           <Box
                    component="img"
                    src={require("../assets/saloonlogo.png")}
                    alt="Logo"
                    sx={{
                      width: { xs: 150, sm: 180, md: 200 },
                      height: "auto",
                      alignSelf: "center",
                      mb: 3,
                      animation: `${pulseLogo} 3s infinite ease-in-out`,
                      filter: `
                        drop-shadow(0 0 8px white)
                        drop-shadow(0 0 16px white)
                        drop-shadow(0 0 24px rgba(149, 117, 205, 1))
                      `
                    }}
                  />

          
            <Typography variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: 700 }}>
              Customer Login
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
              Enter your mobile number to receive OTP
            </Typography>

            <TextField
              label="Mobile Number"
              variant="outlined"
              fullWidth
              margin="normal"
              value={contact}
              inputProps={{ maxLength: 10 }}
              onChange={(e) => setContact(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon color="primary" />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />

            {!isOtpSent ? (
              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={sendOtp}
                disabled={isLoading}
                sx={{
                  py: 1.5, mt: 1, fontWeight: 700,
                  background: 'linear-gradient(45deg, #1b1b1bff, #0d0d0eff)',
              '&:hover': { background: 'linear-gradient(45deg, #0a090aff, #030303ff)' },

                }}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Send OTP"
                )}
              </Button>
            ) : (
              <Fade in={isOtpSent}>
                <Box>
                  {popupmessage && (
                    <Alert
                      icon={<CheckCircleIcon fontSize="inherit" />}
                      severity="success"
                      sx={{ mb: 2 }}
                    >
                      {popupmessage}
                    </Alert>
                  )}

                  <TextField
                    label="Enter OTP"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddIcon color="action" />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleCancel}
                            edge="end"
                            size="small"
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />

                  <Box sx={{ display: "flex", gap: 2, mt: 1, flexDirection: { xs: "column", sm: "row" } }}>
                    <Box sx={{ flex: 1 }}>
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={handleLogin}
                        disabled={isLoading || !otp}
                        endIcon={<ArrowForwardIcon />}
                        sx={{ py: 1.5 }}
                      >
                        {isLoading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          "Verify"
                        )}
                      </Button>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Button
                        variant="outlined"
                        fullWidth
                        size="large"
                        onClick={handleCancel}
                        disabled={isLoading}
                        sx={{ py: 1.5 }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Fade>
            )}

            {errorMessage && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {errorMessage}
              </Alert>
            )}

            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              sx={{ mt: 3 }}
            >
              By continuing, you agree to our Terms of Service and Privacy
              Policy
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 3, mt: 3 }}>
              <Button
                component={Link}
                to="/addusers"
                variant="outlined"
                size="medium"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  borderColor: "primary.main",
                  px: 4,
                  "&:hover": { backgroundColor: "rgba(25,118,210,0.1)" },
                }}
              >
                Create New Account
              </Button>             
            </Box>
             <Typography
                component="button"
                onClick={handleHomeClick}
                sx={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "text.secondary",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  // textDecoration: "underline",
                  "&:hover": {
                    color: "primary.main",
                  },
                }}
              >
                Back to Home Page
              </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
